import React, { useState } from 'react';
import { Login } from './Login.tsx';
import { Register } from './Register.tsx';

export const AuthPage: React.FC = () => {
    const [isLogin, setIsLogin] = useState(true);

    return (
        <div className="auth-page">
            <div className="auth-container">
                <div className="auth-toggle">
                    <button className={isLogin ? 'active' : ''} onClick={() => setIsLogin(true)}>
                        Login
                    </button>
                    <button className={!isLogin ? 'active' : ''} onClick={() => setIsLogin(false)}>
                        Register
                    </button>
                </div>

                {isLogin ? <Login /> : <Register />}
            </div>
        </div>
    );
};
